"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25",
    width: "25",
    height: "25"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9.3,21.7c-2,0-3.5-1.6-3.5-3.5c0-1.2,0.6-2.2,1.5-2.9v-10c0-1.1,0.9-2,2-2c1.1,0,2,0.9,2,2v10c0.9,0.7,1.5,1.7,1.5,2.9 C12.8,20.1,11.2,21.7,9.3,21.7z M9.3,4.3c-0.6,0-1,0.5-1,1v10.3c0,0.2-0.1,0.3-0.2,0.4c-0.8,0.5-1.3,1.3-1.3,2.2 c0,1.4,1.1,2.5,2.5,2.5c1.4,0,2.5-1.1,2.5-2.5c0-0.9-0.5-1.7-1.3-2.2c-0.2-0.1-0.2-0.3-0.2-0.4V5.3C10.3,4.7,9.8,4.3,9.3,4.3z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9.3,19.5c-0.7,0-1.3-0.6-1.3-1.3s0.6-1.3,1.3-1.3s1.3,0.6,1.3,1.3S10,19.5,9.3,19.5z M9.3,17.9C9.1,17.9,9,18,9,18.2 c0,0.3,0.5,0.3,0.5,0C9.5,18,9.4,17.9,9.3,17.9z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9.3,17.9c-0.3,0-0.5-0.2-0.5-0.5V9.1c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v8.3C9.8,17.7,9.6,17.9,9.3,17.9z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M18.8,8.1h-5.3c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h5.3c0.3,0,0.5,0.2,0.5,0.5S19,8.1,18.8,8.1z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.5,25C5.6,25,0,19.4,0,12.5S5.6,0,12.5,0S25,5.6,25,12.5S19.4,25,12.5,25z M12.5,1C6.2,1,1,6.2,1,12.5S6.2,24,12.5,24 S24,18.8,24,12.5S18.8,1,12.5,1z"
  }));
};

exports["default"] = _default;